import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../../shared/components/Modal';
import CreditNoteVerificationModalTable from './CreditNoteVerificationModalTable';
import CreditNoteVerificationModalTableActions from './CreditNoteVerificationModalTableActions';
import Spinner from 'react-bootstrap/Spinner';
import { InvoiceUtils } from './InvoiceUtils';
import FacturaTechHTTP from '../../../../ElectronicBilling/api/FacturaTechHTTP';

const CreditNoteVerificationModal = ({ closeModal, opened, id_factura_t, num_fac_ter, closeModalFinish, providerFE = null, invoiceType = "FACTURA EN SALUD", invoice }) => {

    //Opciones
    const [admisionOptions, setAdmisionOptions] = useState(1);
    const [listPatients, setListPatients] = useState([]);
    const [exceptionsPatients, setExceptionsPatients] = useState([]);
    const [loadingProcess, setLoadingProcess] = useState(false);

    //Sistema
    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("success");

    useEffect(() => {
        getPatientsFromInvoice();
    }, []);

    const onOkModal = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            setAlerShowModal(false);
            setAlertMessageModal("");
            setAlertColorModal("");
            closeModalFinish();
        } else if (colorAlertModal == "warning") {
            setAlerShowModal(false);
            setAlertMessageModal("");
            setAlertColorModal("");
            preGenerateCreditNote();
        } else if (colorAlertModal == "danger") {
            setAlerShowModal(false);
            setAlertMessageModal("");
            setAlertColorModal("");
        } else {
            setAlerShowModal(false);
            setAlertMessageModal("");
            setAlertColorModal("");
        }
    }

    const onToggleModal = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            setAlerShowModal(false);
            setAlertMessageModal("");
            setAlertColorModal("");
            closeModalFinish();
        }
        else if (colorAlertModal == "warning") {
            setAlerShowModal(false);
            setAlertMessageModal("");
            setAlertColorModal("");
        }
        else {
            setAlerShowModal(false);
            setAlertMessageModal("");
            setAlertColorModal("");
        }
    }

    const getPatientsFromInvoice = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}facturas/listar-recibos-factura?id_factura_t=${id_factura_t}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((dataPatients) => {
            setListPatients(dataPatients);
        }).catch(err => {
            console.log(err);
            setListPatients([]);
        });
    }

    const removePatientFromInvoice = (patient) => {
        let data = exceptionsPatients.slice();
        data.push(patient);
        setExceptionsPatients(data);
    }

    const addPatientFromInvoice = (patient) => {
        let data = exceptionsPatients.filter(expPat => expPat.id_recibo != patient.id_recibo);
        setExceptionsPatients(data);
    }

    const generateCreditNoteV2 = async () => {
        setLoadingProcess(true)
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/generar-nota-creditoV2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: id_factura_t,
                excepciones: exceptionsPatients,
                accion: admisionOptions
            })
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((dataPatients) => {
            setLoadingProcess(false);
            setAlertMessageModal("Nota Crédito generada correctamente");
            setAlertColorModal("success");
            setAlerShowModal(true);
        }).catch(err => {
            setLoadingProcess(false);
            setAlertMessageModal("La nota credito no se ha podido generar, por favor intente nuevamente");
            setAlertColorModal("warning");
            setAlerShowModal(true);
            console.log(err);
        });
    }

    const conclutionCreditNoteFacteruraTech = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/generar-nota-creditoV2-concluir-recibos`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: id_factura_t,
                excepciones: exceptionsPatients,
                accion: admisionOptions
            })
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((nota_credito) => {
            console.log({nota_credito})
        }).catch(err => {
            console.log(err);
        });
    }

    const preGenerateCreditNote = async () => {
        switch (parseInt(providerFE.id_factura_electronica_api)) {
            case 1: //Facturatech
                let InvoiceUt = new InvoiceUtils();
                let idsReceipts = InvoiceUt.extractIdForReceipts(invoice);

                if (invoiceType == "FACTURA EN SALUD") { //Factura en Salud
                    await InvoiceUt.getReceiptsById(idsReceipts, invoice.id_tercero, invoice.num_fac_ter, invoice.folio_nota_credito).then((invoiceData) => {
                        FacturaTechHTTP.generateXMLInvoice(invoiceData.factura, "SALUD", invoice.id_factura_t, "NC").then((success) => {
                            if (success == true) {
                                setAlertMessageModal("Nota Crédito Generada correctamente");
                                setAlertColorModal("success");
                                setAlerShowModal(true);
                                conclutionCreditNoteFacteruraTech();
                                console.log("Nota Crédito Generada correctamente");
                                
                            }
                            else {
                                setAlertMessageModal("Ha ocurrido un error transmitiendo la Nota Crédito");
                                setAlertColorModal("danger");
                                setAlerShowModal(true);
                                console.error("Error transmitiendo la nota credito: ", error);
                            }
                        }).catch((error) => {
                            setAlertMessageModal("Ha ocurrido un error en el Sistema");
                            setAlertColorModal("danger");
                            setAlerShowModal(true);
                            console.error("Error en el sistema: ", error);
                            console.log(error);
                        });
                    }).catch((error) => {
                        console.log(error);
                        console.error("Ha ocurrido un error generando la Nota Crédito: ", error);
                        setAlertMessageModal("Ha ocurrido un error generando la Nota Crédito");
                        setAlertColorModal("danger");
                        setAlerShowModal(true);
                    });
                }
                else { //Factura Comercial
                    await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/get-comercial-invoice?id_factura_t=' + id_factura_t, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                        }
                    }).then(response => {
                        if (response.status != 500 && response.status != 403) {
                            return response.json();
                        }
                        else {
                            throw new Error("Data");
                        }
                    }).then(res => {
                        FacturaTechHTTP.generateXMLInvoice(res.factura, "COMERTIAL", data.data.original.id_factura_t, "NC").then((success) => {
                            if (success == true) {
                                setAlertMessageModal("Nota Crédito Generada correctamente");
                                setAlertColorModal("success");
                                setAlerShowModal(true);
                                console.log("Nota Crédito Generada correctamente");
                            }
                            else {
                                setAlertMessageModal("Ha ocurrido un error transmitiendo la Nota Crédito");
                                setAlertColorModal("danger");
                                setAlerShowModal(true);
                                console.error("Error transmitiendo la nota credito: ", error);

                            }
                        }).catch((error) => {
                            //console.log(error);
                            setAlertMessageModal("Ha ocurrido un error transmitiendo la Nota Crédito");
                            setAlertColorModal("danger");
                            setAlerShowModal(true);
                            console.error("Error transmitiendo la nota credito: ", error);

                        });
                    }).catch((error) => {
                        console.log(error);
                        throw new Error("Ha ocurrido un error transmitiendo la Nota Crédito");
                    });
                }
                break;
            default: //Talumm & iFacturaApp
                generateCreditNoteV2();
                break;
        }
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Verificación para Nota Crédito</h5>
                            <br />
                            <h6 className="bold-text">Factura: {num_fac_ter}</h6>
                        </div>

                        <div>
                            <TextField
                                required
                                className='medical-material-form__field'
                                id="formatName"
                                label="Acción para las Admisiones"
                                select
                                value={admisionOptions}
                                InputLabelProps={{
                                    style: { color: '#646777' },
                                    shrink: true
                                }}
                                onChange={(event) => {
                                    setAdmisionOptions(event.target.value);
                                }}
                            >
                                <MenuItem key={1} value={1}>
                                    Clonar Pacientes restantes a una nueva Factura (Recomendado si solo es cambiar el Regimen de algunos pacientes)
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    Dejar Pacientes restantes a Pendientes a Facturar (Recomendado si requiere cambiar valores financieros en las Admisiones)
                                </MenuItem>
                            </TextField>
                        </div>
                        <br />
                        {
                            listPatients.length > 0 ?
                                <CreditNoteVerificationModalTable
                                    reactTableData={listPatients}
                                    removePatientFromInvoice={(patient) => { removePatientFromInvoice(patient) }}
                                    exceptionsPatients={exceptionsPatients}
                                    ReactTableActions={CreditNoteVerificationModalTableActions}
                                    addPatientFromInvoice={addPatientFromInvoice}
                                /> : null
                        }
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                        {loadingProcess == true ? <Spinner animation="border" variant="success" /> : <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                setAlerShowModal(true);
                                setAlertMessageModal("Esta completamente seguro de Generar la Nota Crédito....");
                                setAlertColorModal("warning");
                            }}
                        >
                            Generar Nota Crédito
                        </Button>}

                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOkModal()}
                toggle={() => onToggleModal()}
            />
        </div>
    );
};
export default CreditNoteVerificationModal;
